// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top[data-v-2a8c602c]{font-size:.9375rem;color:#233333;font-weight:600}.top[data-v-2a8c602c],.top .cascader_part[data-v-2a8c602c]{display:flex;align-items:center}.top .daochu[data-v-2a8c602c]{flex:1;display:flex;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
